// extracted by mini-css-extract-plugin
export default {"layout":"Notifications_layout__XH0bP"};